import './config';
import {apiBaseUrl} from './config';
import {getBaseHeader} from './utils';

const USERS = 'users';

const returnResponse = response => {
  const json = response.json();
  if (!response.ok)
    return json.then(error => {throw error});
  return json;
};

export default class UsersService {
  static findAllUsers() {
    return fetch(`${apiBaseUrl}/${USERS}`, {headers: getBaseHeader()})
      .then(returnResponse);
  }

  static createUser(user) {
    const body = JSON.stringify({user: user});
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };
    const method = 'POST';

    return fetch(`${apiBaseUrl}/${USERS}`, {body, headers, method})
      .then(returnResponse);
  }

  static findUserById(userId) {
    return fetch(`${apiBaseUrl}/${USERS}/${userId}`, {headers: getBaseHeader()})
      .then(returnResponse);
  }

	static findCurrentUser() {
    return fetch(`${apiBaseUrl}/${USERS}/current`, {headers: getBaseHeader()})
      .then(returnResponse);
	}
}



// WEBPACK FOOTER //
// ./src/service/sfp/users-service.js